import { cn, Icon } from "@qw/ui";

const CHAT_INTERRUPTED_TITLE = "Interrupted — this didn't complete";
const CHAT_INTERRUPTED_FALLBACK = "This run was interrupted and did not complete. Please try running it again.";

export interface ChatInterruptedDisclosureProps {
  className?: string;
  detail?: string | null;
}

/**
 * A prominent, always-visible notice for a chat turn that was interrupted and
 * abandoned during recovery (a `status: "interrupted"` assistant message).
 * Distinct from `ChatErrorDisclosure` (generation errors) and from the
 * transient "attempting to resume…" busy label — this is the terminal signal
 * that the run gave up and the user should try again.
 */
export const ChatInterruptedDisclosure = ({ className, detail }: ChatInterruptedDisclosureProps) => {
  const body = detail?.trim() || CHAT_INTERRUPTED_FALLBACK;

  return (
    <div
      className={cn(
        "flex items-start gap-1.5 rounded-md border border-destructive/30 bg-destructive/10 px-2 py-1.5 text-sm text-destructive",
        className
      )}
    >
      <Icon icon="error" className="mt-0.5 text-base" />
      <div className="flex flex-col gap-0.5">
        <span className="font-medium">{CHAT_INTERRUPTED_TITLE}</span>
        <span className="text-muted-foreground whitespace-pre-wrap">{body}</span>
      </div>
    </div>
  );
};
